<template>
  <div
    class="row lift lift-sm justify-content-center bg-white py-3 mb-3 rounded"
  >
    <div class="col-2 col-lg-1 text-right d-flex align-items-center">
      <button
        class="btn btn-icon"
        :class="btn"
        type="button"
      >
        <i
          class="fas"
          :class="icon"
        />
      </button>
    </div>
    <div class="col-8 col-lg-10">
      <div class="text-lg">
        {{ title }}
      </div>
      <div class="text-break">
        {{ message }}
      </div>
    </div>
    <div class="col-2 col-lg-1 text-right">
      <small>{{ created_at }}</small>
    </div>
  </div>
</template>
<script>
import { Echo } from '../../plugins/pusher';

export default {
  name: 'UserNotifications',
  props: {
    created_at: { type: String, default: null },
    title: { type: String, default: null },
    message: { type: String, default: null },
    btn: { type: String, default: null },
    icon: { default: String, default: null },
    url: { default: String, default: null },
  },
  mounted() {
    Echo.private(`user.${window.appState.user.id}`).listen(
      'message-received',
      this.fetchMore,
    );
  },
};
</script>
